import { Plus } from 'lucide-react'
import Navigation from '../components/Navigation'

export default function ButtonTestPage() {
  return (
    <div className="min-h-screen p-8">
      <Navigation />
      <div className="max-w-4xl mx-auto space-y-8">
        <h1 className="text-3xl font-bold text-white">按钮渲染测试</h1>
        
        <div className="card">
          <h2 className="text-xl font-semibold text-white mb-4">主按钮测试</h2>
          <div className="space-y-4">
            <button className="btn-primary">
              <Plus className="w-4 h-4 mr-2" />
              新建策略
            </button>
            
            <button className="btn-primary">
              普通主按钮
            </button>
            
            <button className="btn-primary" disabled>
              禁用主按钮
            </button>
          </div>
        </div>
        
        <div className="card">
          <h2 className="text-xl font-semibold text-white mb-4">次要按钮测试</h2>
          <div className="space-y-4">
            <button className="btn-secondary">
              次要按钮
            </button>
            
            <button className="btn-secondary">
              另一个次要按钮
            </button>
          </div>
        </div>
        
        <div className="card">
          <h2 className="text-xl font-semibold text-white mb-4">按钮组合测试</h2>
          <div className="flex space-x-4">
            <button className="btn-secondary">
              取消
            </button>
            <button className="btn-primary">
              <Plus className="w-4 h-4 mr-2" />
              确认
            </button>
          </div>
        </div>
      </div>
    </div>
  )
} 